import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { T } from "@/lib/theme";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const nav = useNavigate();

  const submit = async () => {
    if (pwd.length < 8) return setError("Password must be at least 8 characters");
    if (pwd !== pwd2) return setError("Passwords do not match");
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
    } catch (e) {
      setError(e.response?.data?.detail || "Reset failed");
    } finally { setLoading(false); }
  };

  const inp = { width: "100%", padding: "11px 14px", borderRadius: 8,
    border: `1px solid ${T.border}`, fontSize: 14, marginBottom: 14, outline: "none", color: T.navy };

  return (
    <div style={{ minHeight: "100vh", background: T.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Inter',system-ui,sans-serif", padding: 20 }} data-testid="reset-page">
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap')`}</style>
      <div style={{ background: "#fff", borderRadius: 16, padding: "40px 36px", maxWidth: 440, width: "100%", boxShadow: "0 4px 40px rgba(0,0,0,0.08)" }}>
        <div style={{ textAlign: "center", marginBottom: 22 }}>
          <div style={{ fontSize: 24, fontWeight: 800, color: T.navy }}>WaveScore<span style={{ color: T.green }}>Pro</span></div>
          <div style={{ fontSize: 13, color: T.muted, marginTop: 4 }}>Choose a new password</div>
        </div>
        {!token ? (
          <div data-testid="reset-no-token" style={{ color: "#EF4444", fontSize: 14, textAlign: "center" }}>
            ⚠ Missing reset token. Please use the link from your email.
          </div>
        ) : done ? (
          <div data-testid="reset-done" style={{ textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>✅</div>
            <h2 style={{ color: T.navy, fontSize: 18, fontWeight: 700, marginBottom: 6 }}>Password updated</h2>
            <p style={{ color: T.muted, fontSize: 14 }}>You can now sign in with your new password.</p>
            <button data-testid="reset-signin" onClick={() => nav("/login")}
              style={{ marginTop: 18, padding: "10px 22px", background: T.green, color: "#fff", border: "none", borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
              Sign in
            </button>
          </div>
        ) : (
          <>
            <input data-testid="reset-pwd" style={inp} type="password" placeholder="New password (min 8 chars)"
              value={pwd} onChange={(e) => setPwd(e.target.value)} />
            <input data-testid="reset-pwd2" style={inp} type="password" placeholder="Repeat new password"
              value={pwd2} onChange={(e) => setPwd2(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} />
            {error && <div data-testid="reset-error" style={{ color: "#EF4444", fontSize: 13, marginBottom: 12 }}>⚠ {error}</div>}
            <button data-testid="reset-submit" onClick={submit} disabled={loading}
              style={{ width: "100%", padding: 12, borderRadius: 8, border: "none",
                background: loading ? "#9CA3AF" : T.green, color: "#fff", fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer" }}>
              {loading ? "Saving..." : "Set new password"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
